

// src/redux/cardsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL, bookingPriceApi } from '../../utils/Constants';

// Async thunk for fetching data
export const bookingPrice = createAsyncThunk('BookingPrice', async (latitude, longitude, bookingId) => {
    const token = localStorage.getItem("Token")
    const headers = {
        "Authorization": token, "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
    }
    try {
        const url = BASE_URL + bookingPriceApi + `?latitude=${latitude}&longitude=${longitude}&bookingId=${bookingId}`
        const response = await axios.get(url, { headers }); // Replace with your API endpoint
        return response.data;
    } catch (error) {
        throw error;
    }
});

const BookingPriceSlice = createSlice({
    name: 'bookingPriceReducer',
    initialState: {
        data: null,
        loading: 'idle',
        error: null,
    },
    reducers: {
        clearData: (state) => {
            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(bookingPrice.pending, (state) => {
                state.loading = 'pending';
            })
            .addCase(bookingPrice.fulfilled, (state, action) => {
                state.loading = 'idle';
                state.data = action.payload;
                state.error = null;
            })
            .addCase(bookingPrice.rejected, (state, action) => {
                state.loading = 'idle';
                state.error = action.error.message;
            });
    },
});

export const { clearBookingPriceData } = BookingPriceSlice.actions

export default BookingPriceSlice.reducer;
